module.exports = __webpack_public_path__ + "static/bg-cccd15516d4d8ac11cefece9803f081c.png";